<style lang="less">
@import "../../styles/public/public.less";
.page_titile{
    position: absolute;
    top: -20px;
    left: 30px;
    padding: 0px 20px;
    height: 40px;
    background: #63ab63;
    font-weight: 600;
    letter-spacing: 5px; 
    border-top-left-radius: 24px;
    border-top-right-radius: 0px;
    border-bottom-right-radius: 24px;
    border-bottom-left-radius: 0px;              
}
</style>
<template>
  <div class="page_titile media_w_w20 display_row_jc_ac">
    <span>{{titles}}</span>
  </div>
</template>

<script>
export default {
  props: {
    titles: {
      type: String, //标题
      default: ""
    }
  },
  components: {},
  data() {
    return {};
  },
  methods: {},
  mounted() {},
  directives: {}
};
</script>




// WEBPACK FOOTER //
// title.vue?9bad244e